<template>
    <sections>
        <section-contact heading="Contact" content="<article-contact />"></section-contact>
    </sections>
</template>

<script setup>
const $config = useRuntimeConfig();
useSeo().buildHead({
    title: 'Contact | ' + $config.public.siteName,
    description: 'Please drop me a message and I will reply as soon as possible - thank you!',
    index: true,
});
</script>
